export default __webpack_public_path__ + "static/media/PeppaPig_02.7c8e1fc6.png";